var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.953 7.28a.957.957 0 0 1 1.353 1.352L16.938 16l7.368 7.368.066.073a.957.957 0 0 1-1.345 1.345l-.073-.066-7.368-7.368-7.368 7.368a.956.956 0 0 1-1.353-1.352l7.368-7.369-7.367-7.367A.956.956 0 1 1 8.218 7.28l7.367 7.367z"
  })));
};
export default SvgCross;